import { render, staticRenderFns } from "./ContributionsV2.vue?vue&type=template&id=8c68d092&scoped=true"
import script from "./ContributionsV2.vue?vue&type=script&lang=ts"
export * from "./ContributionsV2.vue?vue&type=script&lang=ts"
import style0 from "./ContributionsV2.vue?vue&type=style&index=0&id=8c68d092&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c68d092",
  null
  
)

export default component.exports